import { IonApp, IonRoute, IonRouterOutlet, setupIonicReact } from "@ionic/react";
import { IonReactRouter } from "@ionic/react-router";

import "@ionic/react/css/core.css";
import "./index.css";

import { iosTransitionAnimation } from "@ionic/core";
import { initOpenApi } from "./clients/open_api_injection";
import { BottomBar } from "./components/bottom-bar";
import { ChatPhotoRestorationListener } from "./components/providers/chat-photo-restoration-listener";
import { AiChatModal } from "./features/ai-chat/components/ai-chat-modal";
import { ChatSessionProvider } from "./features/ai-chat/hooks/use-chat-session";
import { AppSplash } from "./components/splash/app-splash";
import { ToastProvider } from "./components/providers/toast-provider";
import { PrivateAuthGuard } from "./components/route/auth-guard";
import { AuthRouteGuard } from "./components/route/auth-guard/auth-route-guard";
import { PaywallGuard } from "./components/route/auth-guard/paywall-guard";
import { OnboardingTransitionProvider } from "./features/user-profile/context/onboarding-transition-context";
import { usePageTracking } from "./hooks/use-page-tracking";
import { publicRoutes } from "./router/public-routes";
import { privateRoute } from "./router/routes";

setupIonicReact({
  rippleEffect: true,
  mode: "ios",
});

function AppRoutes() {
  usePageTracking();
  return (
    <>
      <IonRouterOutlet animation={iosTransitionAnimation}>
        {publicRoutes.map((routeItem) => {
          const routeElement = <>{routeItem.children}</>;
          return (
            <IonRoute
              key={routeItem.path}
              path={routeItem.path}
              exact={routeItem.exact ?? true}
              render={() => routeElement}
            />
          );
        })}
        {privateRoute.map((routeItem) => {
          const routeElement = <>{routeItem.children}</>;
          return (
            <IonRoute
              key={routeItem.path}
              path={routeItem.path}
              exact={routeItem.exact ?? true}
              render={() => <PrivateAuthGuard>{routeElement}</PrivateAuthGuard>}
            />
          );
        })}
      </IonRouterOutlet>

      <BottomBar />
      <AiChatModal />
      <PaywallGuard />
      <AuthRouteGuard />
      <ChatPhotoRestorationListener />
    </>
  );
}

const App: React.FC = () => {
  initOpenApi();

  return (
    <IonApp>
      <IonReactRouter>
        <ToastProvider>
          <OnboardingTransitionProvider>
            <ChatSessionProvider>
              <AppRoutes />
            </ChatSessionProvider>
          </OnboardingTransitionProvider>
        </ToastProvider>
      </IonReactRouter>
      {/* Single boot splash overlay, on top of the router. Covers all boot-time loading
          screens until the app is ready, then unmounts. */}
      <AppSplash />
    </IonApp>
  );
};

export default App;
